// Job type definitions for frontend

export enum JobType {
  DELIVERY = 'delivery',
  PICKUP = 'pickup',
  INSTALLATION = 'installation',
  MAINTENANCE = 'maintenance',
  TRANSFER = 'transfer',
}

export enum JobStatus {
  DRAFT = 'draft',
  ASSIGNED = 'assigned',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  ON_HOLD = 'on_hold',
}

export enum JobPriority {
  LOW = 'low',
  NORMAL = 'normal',
  HIGH = 'high',
  URGENT = 'urgent',
}

export type User = {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone_number?: string;
  is_active: boolean;
};

export type Shipment = {
  id: string;
  bl_number: string;
  shipment_type: string;
  origin_address_id?: string | null;
  destination_address_id?: string | null;
  planned_departure_at?: string | null;
  planned_arrival_at?: string | null;
  actual_arrival_at?: string | null;
  created_at: string;
  updated_at: string;
  created_by_user?: User;
};

export type Job = {
  id: string;
  job_number: string;
  job_code?: string | null;
  job_type: JobType | null;
  status: JobStatus;
  priority: JobPriority;
  order_id: string;
  assigned_driver_id?: string | null;
  assigned_supervisor_id?: string | null;
  planned_start_at?: string | null;
  planned_end_at?: string | null;
  actual_start_at?: string | null;
  actual_end_at?: string | null;
  estimated_duration_hours?: number | null;
  driver_location_lat?: number | null;
  driver_location_lon?: number | null;
  driver_location_updated_at?: string | null;
  notes?: string | null;
  completion_notes?: string | null;
  created_at: string;
  updated_at: string;
  created_by_user_id: string;
  // Associations
  order?: import('../types/order').Order;
  shipments?: Shipment[];
  tasks?: import('../types/task').Task[];
  assigned_driver?: User;
  assigned_supervisor?: User;
  created_by_user?: User;
};

export type JobCreateInput = {
  job_number?: string;
  job_code?: string | null;
  job_type?: JobType | null;
  order_id: string;
  priority: JobPriority;
  assigned_driver_id?: string | null;
  assigned_supervisor_id?: string | null;
  planned_start_at?: Date | null;
  planned_end_at?: Date | null;
  estimated_duration_hours?: number | null;
  notes?: string | null;
};

export type JobUpdateInput = Partial<JobCreateInput> & {
  status?: JobStatus;
  actual_start_at?: Date | null;
  actual_end_at?: Date | null;
  completion_notes?: string | null;
  driver_location_lat?: number | null;
  driver_location_lon?: number | null;
  driver_location_updated_at?: Date | null;
};

export type JobAssignInput = {
  driver_id: string;
  supervisor_id?: string;
  planned_start_at?: string;
  planned_end_at?: string;
};

export type JobStats = {
  total: number;
  draft: number;
  assigned: number;
  in_progress: number;
  completed: number;
  cancelled: number;
  on_hold: number;
  overdue: number;
  byType: {
    delivery: number;
    pickup: number;
    installation: number;
    maintenance: number;
    transfer: number;
  };
  byPriority: {
    low: number;
    normal: number;
    high: number;
    urgent: number;
  };
};

export type JobsApiResponse = {
  jobs: Job[];
  pagination: {
    total: number;
    pages: number;
    current_page: number;
    per_page: number;
  };
};
